import { B2BUserRole } from "@spartacus/core";
import { B2BUserService } from "@spartacus/organization/administration/core";

export class GonvarriB2BUserService extends B2BUserService {
    override getAllRoles(): B2BUserRole[] {
        return [
            B2BUserRole.CUSTOMER,
            B2BUserRole.ADMIN,
          ];
    }
}